import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ClassesComponent } from './classes/classes.component';
import { BreastfeedingComponent } from './breastfeeding/breastfeeding.component';
import { RequestAppointmentComponent } from './request-appointment/request-appointment.component';
import { ResourcesComponent } from './resources/resources.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent }, 
  { path: 'about', component: AboutComponent },
  { path: 'breastfeeding', component: BreastfeedingComponent },
  { path: 'classes', component: ClassesComponent },
  { path: 'requestappointment', component: RequestAppointmentComponent },
  { path: 'resources', component: ResourcesComponent },
  { path: 'resources/:id', component: ResourcesComponent },

//  { path: 'resources/article', component: ArticleComponent },
  { path: '', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
